import { Navigate, RouteObject } from "react-router";
import { ReportRoute } from "@/routes/processes/[processId]/process/inspections/[reportId]/inspection-route";
import { ReportsIndexRoute } from "./_components/reports-index-route";
import { ContactsIndexRoute } from "./[reportId]/contacts/contacts_index_route";
import { CustomerIndexRoute } from "./[reportId]/customers/customers-index-route";
import { CompanyIndexRoute } from "./[reportId]/company/company-index-route";
import { MetadataIndexRoute } from "./[reportId]/metadata/metadata-index-route";
import ResultsIndexRoute from "./[reportId]/results/results-index-route";
import CountingIndexRoute from "./[reportId]/countings/countings-index-route";
import { DifferentiationIndexRoute } from "./[reportId]/differentiation/_components/differentiation-index-route";

export const inspectionsRoutes: RouteObject[] = [
  {
    index: true,
    element: <ReportsIndexRoute />,
  },
  {
    path: ":reportId",
    element: <ReportRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="metadata" />,
      },
      {
        path: "metadata",
        element: <MetadataIndexRoute />,
      },
      {
        path: "results",
        element: <ResultsIndexRoute />,
      },
      {
        path: "countings",
        element: <CountingIndexRoute />,
      },
      {
        path: "differentiation",
        element: <DifferentiationIndexRoute />,
      },
      {
        path: "contacts",
        element: <ContactsIndexRoute />,
      },
      {
        path: "customers",
        element: <CustomerIndexRoute />,
      },
      {
        path: "company",
        element: <CompanyIndexRoute />,
      },
    ],
  },
];
